fragment FormForLandingPage on Form {
    id
    name
    creatorUser {
        id
        name
    }
    lastUpdatedTime
    numSubmissions
    lastSubmittedTime
}
